import {RxCollection} from 'rxdb';
import {DataSource} from './data-source';
import {ShapeModel} from '../../models/shape.model';

export class ShapesDataSource extends DataSource<ShapeModel> {
    constructor(collection: RxCollection) {
        super(collection);
    }

    async findByShapeId(shapeId: string): Promise<ShapeModel | null> {
        const twentyFourHoursAgo = Date.now() - (24 * 60 * 60 * 1000);

        const docs = await this.collection
            .find({
                selector: {
                    id: shapeId,
                    createdAt: {$gte: twentyFourHoursAgo},
                },
            })
            .exec();

        return docs.length > 0 ? docs[0].toJSON() as ShapeModel : null;
    }

    async saveShapes(shapeId: string, points: any[]): Promise<ShapeModel> {
        const shape: ShapeModel = {
            id: shapeId,
            createdAt: Date.now(),
            points: points.map((p) => ({
                shape_pt_lat: p.shape_pt_lat,
                shape_pt_lon: p.shape_pt_lon,
                shape_pt_sequence: p.shape_pt_sequence,
            })),
        };

        const doc = await this.collection.insert(shape);
        return doc.toJSON() as ShapeModel;
    }

    async removeExpiredShapes(): Promise<number> {
        const twentyFourHoursAgo = Date.now() - (24 * 60 * 60 * 1000);

        const expiredDocs = await this.collection
            .find({
                selector: {
                    createdAt: {
                        $lt: twentyFourHoursAgo,
                    },
                },
            })
            .exec();

        if (expiredDocs.length > 0) {
            await Promise.all(expiredDocs.map((doc) => doc.remove()));
            console.log(`Eliminados ${expiredDocs.length} shapes expirados`);
        }

        return expiredDocs.length;
    }
}
